import ExecutionStatus from "../../../../../types/execution-status";
import PublicStatus from "../../../../../types/public-status";

export enum OrderCargoOrderFinishedListParamsSortKey {
  ORDER_START_DATE_ASC = "ORDER_START_DATE_ASC",
  ORDER_START_DATE_DESC = "ORDER_START_DATE_DESC",
  INTERNAL_ORDER_ID_ASC = "INTERNAL_ORDER_ID_ASC",
  INTERNAL_ORDER_ID_DESC = "INTERNAL_ORDER_ID_DESC",
}

type OrderCargoOrderFinishedListParams = {
  internalOrderId?: number;
  isUrgent?: boolean;
  client?: string;
  dispatch?: string;
  driver?: string;
  externalOrderId?: string;
  address?: string;
  pickupAddress?: string;
  intermediateAddress?: string;
  destinationAddress?: string;
  taxi?: string;
  passenger?: string;
  executionStatus?: ExecutionStatus;
  publicStatus?: PublicStatus;
  page: number;
  pageSize: number;
  sortKey?: OrderCargoOrderFinishedListParamsSortKey;
  fleetPartner?: string;
  excludeFleetPartner?: string;
  orderStartDateTo?: Date;
  orderStartDateFrom?: Date;
};

export default OrderCargoOrderFinishedListParams;
